<div class="menu-wrapper">
  <div
    #ttip="qmTooltip"
    [qmTooltip]="menu"
    (click)="openMenu($event, ttip)"
    class="btn-open-menu">
    <fa-icon [icon]="['fas', 'ellipsis-v']"></fa-icon>
  </div>
</div>

<ng-template #menu let-alarm="alarm">
  <div class="action-menu">
    <div
      *ngFor="let locateRow of locateRows"
      (click)="focusMarker(locateRow)"
      class="action-menu-item">
      <fa-icon [icon]="['far', 'crosshairs']"></fa-icon>
      <span>{{ 'Locate' | translate }} {{ locateRow.label }}</span>
    </div>
    <div *ngIf="!disabledByUser"
      (click)="setAlarmActivity(alarm, false)"
      [ngClass]="{
        'action-menu-item btn-disable': true,
        'btn-no-rights': !hasUserRightsToDisableAlarm
      }"
      ngbTooltip="{{ 'No rights' | translate }}"
      placement="right"
      [disableTooltip]="hasUserRightsToDisableAlarm">
      <fa-icon [icon]="['far', 'calendar-times']"></fa-icon>
      <span>{{ 'Disable' | translate}}</span>
    </div>
    <div
      *ngIf="disabledByUser"
      (click)="setAlarmActivity(alarm, true)"
      [ngClass]="{
        'action-menu-item btn-enable': true,
        'btn-no-rights': !hasUserRightsToDisableAlarm
      }"
      ngbTooltip="{{ 'No rights' | translate }}"
      placement="right"
      [disableTooltip]="hasUserRightsToDisableAlarm"
      >
      <fa-icon [icon]="['far', 'calendar-plus']"></fa-icon>
      <span>{{ 'Enable' | translate }}</span>
    </div>
  </div>
</ng-template>
